import { z } from "zod";
export const GovernanceCoverageV1Schema = z
    .object({
    schemaVersion: z.literal("governance-coverage.v1.0"),
    coveragePercent: z.number().min(0).max(100),
    blockingFactors: z.array(z.string().min(1)),
    allowsFullPassLanguage: z.boolean(),
    downgradeReasons: z.array(z.string().min(1)),
})
    .strict();
//# sourceMappingURL=governance-coverage.js.map